<template>
  <div class="pa-0">
    <v-list two-line class="pa-0 lx-dash-list" color="transparent">
      <v-list-item class="ma-2 py-1 px-6 elevation-3" v-bind:class="[compColor.contentFrameBack]" style="border-radius:3px;" v-if="!newsList || newsList.length <= 0">
        <v-list-item-content v-bind:class="[compColor.widget.text]">
          <div class="flex layout-column px-3" v-bind:style="{'border-left': '4px solid  #eceff1','border-radius': '5px'}">
            <div class="font-weight-bold subtitle-2 my-1" style="line-height: 1.0rem;">{{ $t('NEWS.NOTHING_TO_SHOW') }}</div>
          </div>
        </v-list-item-content>
      </v-list-item>

      <div class="ma-2 elevation-3" v-for="(item, index) in newsList" :key="index">
        <v-list-item class="py-1 px-6" v-bind:style="{'background-color': compColor.context.background}" style="border-radius:3px;">

          <v-list-item-content v-bind:class="[compColor.widget.text]">
            <div class="flex layout-column px-3" v-bind:style="{'border-left': '4px solid #eceff1','border-radius': '5px'}">

              <!-- headline with subheading -->

              <div class="layout-row">
                <div class="flex font-weight-bold subtitle-1 my-1" style="line-height: 1.0rem;">{{ item.headline }}</div>
                <div v-if="item.isWelcomeNews" class="caption layout-row layout-align-start-start" style="width:81px;cursor:pointer;" @click="hideWelcomeNews()">
                  <v-icon small class="mr-1" :color="compColor.primeColor" style="padding-top:2px;">mdi-close-circle-outline</v-icon>
                  <span :style="{color: compColor.primeColor}">ausblenden</span>
                </div>
              </div>
              <div v-if="item.subheading" class="font-weight-regular my-1" style="line-height: 1.0rem;font-size: 14px;">{{ item.subheading }}</div>

              <v-divider class="mb-1" v-bind:class="[compColor.divider]"></v-divider>

              <!-- Content elements -->

              <div v-if="item.contentElements">
                <div v-for="(element, index) in item.contentElements" :key="index" class="font-weight-regular subtitle-2 my-1 layout-row" style="line-height: 1.0rem;">
                  <span class="flex-35" v-if="element.title">{{ element.title }}:</span>
                  <span class="ml-2 flex" v-html="element.value"></span>
                </div>
              </div>

              <!-- Actions/Buttons -->

              <div v-if="item.actions" class="font-weight-regular subtitle-2 mt-3 layout-row">
                <div v-for="(action, index) in item.actions" :key="index" class="layout-row flex">

                  <!-- link -->

                  <v-btn v-if="action.action==='link'"
                         @click="openLinkDialog(action.param)"
                         :dark="compColor.isInDarkMode"
                         class="white--text text-none ml-2 pa-5 flex"
                         :color="compColor.primeColor"
                         dense
                         depressed>
                    {{ action.name }}
                  </v-btn>

                  <!-- download -->

                  <v-btn v-if="action.action === 'download'"
                         :dark="compColor.isInDarkMode"
                         @click="download(action)"
                         class="white--text text-none ml-2 pa-5 flex"
                         :color="compColor.primeColor"
                         dense
                         depressed>
                    {{ action.name }}
                  </v-btn>

                  <!-- method -->

                  <v-btn v-if="action.action === 'method'"
                         @click="handleFunctionCall(action.param)"
                         :dark="compColor.isInDarkMode"
                         class="white--text text-none ml-2 pa-5 flex"
                         :color="compColor.primeColor"
                         dense
                         depressed>
                    {{ action.name }}
                  </v-btn>

                  <!-- confirm -->

                  <v-btn v-if="action.action === 'confirm'"
                         @click="sendConfirmation(item.headline)"
                         :dark="compColor.isInDarkMode"
                         class="white--text text-none ml-2 pa-5 flex"
                         :color="compColor.primeColor"
                         dense
                         depressed>
                    {{ action.name }}
                  </v-btn>
                </div>
              </div>

              <!-- valid from date -->

              <span v-if="!item.isWelcomeNews"
                    class="text--lighten-2 font-weight-regular caption mt-2"
                    style="line-height: 1.0rem;"
                    :class="[compColor.textInput + '--text']">
                {{ $t('NEWS.VALID_FROM_DATE') }} {{ item.validFromDate | formatDate('DD.MMM YYYY') }}
              </span>

            </div>
          </v-list-item-content>
        </v-list-item>
      </div>
    </v-list>

    <!-- request recall successful send -->

    <v-dialog
      persistent
      v-model="showNewsDialog"
      max-width="480"
      hide-overlay
      :dark="compColor.isInDarkMode"
      :color="compColor.primeColor"
      style="overflow:hidden;"
    >
      <div class="elevation-10 layout-column" style="border-radius: 6px;"
           v-bind:style="{background: compColor.contentFrame}">

        <!-- HEADER -->

        <div class="text-h6 font-weight-light pa-3 layout-row layout-align-center-center"
             :class="isDarkMode? 'blue-grey--text text--lighten-2' : ' grey--text text--darken-2'">
          {{ $t('NEWS.REQUEST_RECALL.HEADER') }}
        </div>
        <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

        <!-- CONTENT (default slot) -->

        <div class="ma-1 px-3 py-5 layout-row elevation-3" style="border-radius: 5px;position: relative;" :style="{'background': compColor.lxExpansion.background}">
          <div class="layout-column layout-align-center-center mr-3">
            <v-avatar tile :color="isDarkMode ? compColor.prime : 'grey lighten-3'">
              <v-icon :color="isDarkMode ? 'white' : compColor.primeColor">info</v-icon>
            </v-avatar>
          </div>
          <div class="flex layout-column layout-align-center-start" :class="isDarkMode? 'blue-grey--text text--lighten-2' : 'blue-grey--text text--darken-2'">{{ $t('NEWS.REQUEST_RECALL.CONTENT') }}</div>
        </div>

        <!-- ACTIONS -->

        <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>
        <div class="layout-row layout-align-end-center pa-1">
          <v-btn depressed :color="compColor.prime" :dark="isDarkMode" class="flex white--text text-none mr-1" @click="showNewsDialog = false">
            {{ $t('buttons.close.title') }}
          </v-btn>
        </div>
      </div>
    </v-dialog>

    <!-- Link dialog -->

    <link-dialog
      :showLinkDialog="showLinkDialog"
      :selected-link="selectedLink"
      @close-link-dialog="closeLinkDialog">
    </link-dialog>
  </div>
</template>

<script>
function revokeObjectURL (url) {
  setTimeout(() => {
    // For firefox it is necessary to delay revoking the ObjectURL
    URL.revokeObjectURL(url)
  }, 100)
}

import LinkDialog from "@/views/Dashboard/LinkDialog"

export default {
  name: 'News',
  components: { LinkDialog },
  data () {
    return {
      newsList: [],
      showNewsDialog: false,
      showLinkDialog: false,
      selectedLink: null,
    }
  },

  created () {
    this.getData()
  },

  methods: {
    /**
     * Get news from database
     */
    getData () {
      let opts = { sort: { validFromDate: -1 } };

      this.$http.get('/dashboard/news?config={"opts":' + JSON.stringify(opts) + '}')
        .then(res => {
          if (res.data) {
            this.newsList = res.data || []
          }
        })
        .catch(this.NotifyError)
    },

    /**
     * Download selected document in dashboard
     *
     * @param action The selected download action
     */
    download (action) {
      if (action && action.path && action.filename) {
        this.$http.getAsBlob('/dashboard/news/download/' + encodeURIComponent(action.path))
          .then((res) => {
            setTimeout(() => {
              if (res.data) {
                let objectURL = URL.createObjectURL(res.data)
                const hiddenElement = document.createElement('a')

                hiddenElement.style.display = 'none'
                hiddenElement.href = objectURL
                hiddenElement.setAttribute('download', action.filename)
                document.body.appendChild(hiddenElement)
                hiddenElement.click()
                document.body.removeChild(hiddenElement)

                revokeObjectURL(objectURL)
              }
            }, 200)
          })
          .catch(this.NotifyError)
      }
    },

    /**
     * Send confirmation mail to company
     *
     * @param headLine The headline of news
     */
    sendConfirmation (headLine) {
      this.$http.post('/dashboard/confirm', { text: headLine })
        .then(() => {
          this.NotifySuccess({}, this.$t('NEWS.SEND_CONFIRMATION_SUCCESS'))
        })
        .catch(this.NotifyError)
    },

    /**
     * Call function, if news has a method and button is clicked
     *
     * @param functionName
     */
    handleFunctionCall (functionName) {
      this[functionName]()
    },

    requestRecall () {
      this.$http.post('/dashboard/requestRecall')
        .then(() => {
          this.showNewsDialog = true
        })
        .catch(this.NotifyError)
    },

    /**
     * Open link dialog
     *
     * @param link
     */
    openLinkDialog (link) {
      this.showLinkDialog = true
      this.selectedLink = link
    },

    /**
     * Close dialog and delete selected link
     *
     */
    closeLinkDialog () {
      this.showLinkDialog = false

      this.$nextTick(() => {
        this.selectedLink = null
      })
    },

    /**
     * Hide the welcome news by user interaction
     */
    hideWelcomeNews () {
      this.$http.put('/dashboard/hideWelcomeNews', {})
        .then(() => {
          this.getData()
        })
        .catch(() => {})
    }
  },

  watch: {
    '$route' (to) {
      if (to.name === 'Dashboard') {
        this.getData()
      }
    }
  }
}
</script>

